module.exports = __webpack_public_path__ + "static/media/52logo.ad257a44.png";